import Head from 'next/head';
import PropTypes from 'prop-types';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export default function LCHead({
  title,
  description,
  canonical,
  image,
  author,
  editor,
  noIndex,
  appId,
  appUrl,
  iconUrl,
}) {
  const { width } = useWindowDimensions();
  return (
    <Head>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {image && <meta property="og:image" content={image} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {author && <meta property="author" content={author} />}
      {editor && <meta property="editor" content={editor} />}
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      {width < 1024 && appId && (
        <meta name="apple-itunes-app" content={`app-id=${appId}`} />
      )}
      {width < 1024 && appUrl && iconUrl && (
        <>
          <meta name="smartbanner:title" content="Smart Application" />
          <meta name="smartbanner:author" content="SmartBanner Contributors" />
          <meta name="smartbanner:price" content="FREE" />
          <meta
            name="smartbanner:price-suffix-google"
            content=" - In Google Play"
          />
          <meta name="smartbanner:icon-google" content={`${iconUrl}`} />
          <meta name="smartbanner:button" content="VIEW" />
          <meta name="smartbanner:button-url-google" content={`${appUrl}`} />
          <meta name="smartbanner:enabled-platforms" content="android,ios" />
          <meta name="smartbanner:close-label" content="Close" />
        </>
      )}
      <link rel="shortcut icon" href="/favicon.ico" />
    </Head>
  );
}

LCHead.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonical: PropTypes.string,
  image: PropTypes.string,
  author: PropTypes.string,
  editor: PropTypes.string,
  noIndex: PropTypes.bool,
  appId: PropTypes.string,
};
